<template>
    <div>
        <!-- 此页面打开格式： /oauth/authorize?client_id=xxx&redirect_uri=yyy -->
    </div>
</template>

<script>
import { getQueryString, httpPostSecret } from "@/utils/utils"

export default {
    name: "slider",
    data() {
        return {
            dd: '11'
        }

    },
    mounted() {
        const clientId = getQueryString('client_id')
        const redirectUri = getQueryString('redirect_uri')
        const additional = getQueryString('additional')

        // 直接跳转res.data地址
        this.asyncAuth(clientId, redirectUri, additional)
    },
    methods: {
        async asyncAuth(clientId, redirectUri, additional) {
            const url = "/api/user/authorize2nd"
            let params = { client_id: clientId, redirect_uri: redirectUri, additional }
            const res = await httpPostSecret(url, params)
            if(res.rspCode !== '000000'){
                this.$message.error(res.rspMsg);
                return
            }
            location.replace(res.data);
        }
    }
}
</script>

<style lang="less"></style>
